export function ensureInt(id) {
  const rvId = parseInt(id, 10);

  if (!Number.isNaN(rvId)) {
    return rvId;
  }

  return undefined;
}
